module.exports = __webpack_public_path__ + "static/the_angry-3b61a5d35af85f5f08cb5d183868dedc.png";